import { render } from "./DocumentBrowserBreadcrumb.vue?vue&type=template&id=89d62516&ts=true"
import script from "./DocumentBrowserBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./DocumentBrowserBreadcrumb.vue?vue&type=script&lang=ts"

import "./DocumentBrowserBreadcrumb.vue?vue&type=style&index=0&id=89d62516&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__